import { store } from '../../store';
import toLower from 'lodash/toLower';
import startCase from 'lodash/startCase';
import {
  getBrowserName,
  injectIntoDataLayerWithEvent,
  isMobileDevice,
  sendCleverTapEvent,
  logCTEvent
} from '../library';
import _ from 'lodash';
import { LOG_TYPE, PAGE_NAMES } from './eventsConstants';

const enrichEventObject = () => {
  const {
      rootReducer: {
        userSessionReducer: {
          user_session: { email, user_id, country_code, account_type }
        },
        userFlowReducer: { currentScreen }
      }
    } = store.getState(),
    eventData = {};
  //Default values
  eventData.custom = {
    device_type: isMobileDevice() ? 'Mobile_Web' : 'Web',
    browser_name: getBrowserName(),
    language_preference: navigator.language || navigator.userLanguage,
    user_id,
    page_name: currentScreen,
    remitter_country: country_code,
    email
  };
  account_type && (eventData.custom.account_type = startCase(toLower(account_type)));
  return eventData;
};

const logEvent = (
  eventName,
  flowType,
  eventProperties = {},
  type,
  ctPushProfile = false,
  ctProfileData = null
) => {
  const defaultData = enrichEventObject();
  defaultData.custom = {
    flowType,
    ...defaultData.custom,
    ...eventProperties
  };

  const camelCaseEventName = _.camelCase(eventName);
  const snakeCaseEventName = _.snakeCase(eventName);

  switch (type) {
    case LOG_TYPE.CLEVER_TAP:
      sendCleverTapEvent(
        camelCaseEventName,
        eventProperties,
        ctPushProfile,
        ctProfileData,
        flowType
      );
      break;

    case LOG_TYPE.GA:
      injectIntoDataLayerWithEvent(snakeCaseEventName, defaultData.custom);
      break;

    default:
      //Clevertap + Google Analytics
      sendCleverTapEvent(
        camelCaseEventName,
        eventProperties,
        ctPushProfile,
        ctProfileData,
        flowType
      );
      injectIntoDataLayerWithEvent(snakeCaseEventName, defaultData.custom);
      break;
  }
};
const capitalizePageName = (eventProperty) => {
  if (!eventProperty?.pageName) return;
  const { pageName } = eventProperty;
  eventProperty.pageName = _.startCase(pageName);
  return eventProperty.pageName;
};

export const moveKeysToTop = (obj, keysToMove) => {
  const reordered = Object.fromEntries([
    ...keysToMove.filter((key) => key in obj).map((key) => [key, obj[key]]),
    ...Object.entries(obj).filter(([key]) => !keysToMove.includes(key))
  ]);
  return reordered;
};

// Only for Clevertap with new Events Structure,
const logEventV2 = (eventName, eventProperty = {}) => {
  capitalizePageName(eventProperty);
  const orderedEventProperty = moveKeysToTop(eventProperty, ['pageName']);
  logCTEvent(eventName, orderedEventProperty);
};

export { logEvent, logEventV2 };

export const getPageName = () => {
  const currentUrl = window.location.pathname;
  const cleanUrl = currentUrl.split(/[?#]/)[0].replace(/\/+$/, '');

  const segments = cleanUrl.split('/').filter(Boolean);
  const lastSegment = segments.length ? segments[segments.length - 1].toLowerCase() : '';
  switch (lastSegment) {
    case 'dashboard':
      return PAGE_NAMES.DASHBOARD;
    case 'referrals':
      return PAGE_NAMES.REFER_AND_EARN;
    case 'payee-list':
      return PAGE_NAMES.PAYEE_LIST;
    case 'promotions':
      return PAGE_NAMES.PROMOTIONS;
    case 'instapoints':
      return PAGE_NAMES.INSTAPOINT_DASHBOARD;
    case 'transfer-money':
      return PAGE_NAMES.SEND_MONEY;
    case 'transaction-history':
      return PAGE_NAMES.TRANSACTION_HISTORY;
    case 'signin':
      return PAGE_NAMES.SIGNIN;
    case 'profile':
      return PAGE_NAMES.PROFILE;
    case 'payment-option':
      return PAGE_NAMES.MANAGE_PAYMENT_OPTION;
    case 'subscribe':
      return PAGE_NAMES.SUBSCRIBE;
    case 'help-center':
      return PAGE_NAMES.HELP_CENTER;
    case 'post-logout':
      return PAGE_NAMES.LOGOUT;
    case 'amaze':
      return PAGE_NAMES.AMAZE;

    default:
      return 'Unknown Page';
  }
};
